<template>
  <div
    class="bg-grey-lighter rounded-t-4xl overflow-hidden h-[70svh] sm:h-[65svh] md:h-[60vh] lg:h-[55vh]"
  >
    <div class="bg-white h-full overflow-y-auto overscroll-contain rounded-4xl" style="height: 100%">
      <div class="mb-4 leading-normal">
        <div class="font-bold text-lg text-center mb-6">
          REVISED PAFCPIC ELECTION CODE 2023
        </div>
        <div class="font-bold mb-4">ARTICLE 1. - TITLE</div>
        <div class="mb-4">
          This code shall be known as the “Election Code of the Philippine Army
          Finance Center Producers Integrated Cooperative (PAFCPIC).”
        </div>
        <div class="font-bold mb-4">ARTICLE 2. - DEFINITION OF TERMS.</div>
        <div class="mb-4">
          Code - shall mean the Election Code of the Philippine Army Finance
          Center Producers Integrated Cooperative.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Member Entitled to Vote (MEV)</span> - is a member who satisfies the
          following criteria/conditions:
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Must be a regular member of the cooperative for at least one
          (1) year and has contributed share capital equivalent to twelve
          monthly contribution one (1) year as of the end of the Fiscal Year
          prior to the scheduled General Assembly meeting called for the
          purpose.
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> Has not been delinquent in the payment of any amortization
          of his/her loan with the cooperativeimmediately preceding the
          election.
        </div>
        <div class="mb-4">
          <span class="font-semibold">c.</span> Participates and attends in Cooperative's parliamentary
          affairs, (Regular or Representative. A member who absented himself for
          two (2) Immediately pastgeneral assembly meetingsbut who attends the
          current one shall be restored to his voting rights in the next General
          Assembly Meeting.
        </div>
        <div class="mb-4">
          <span class="font-semibold">e.</span> Has attended and completed the prescribed Pre-Membership
          Cooperative Seminar.
        </div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> Obeys, the rules and regulations provided by R.A. 9520 and
          other related legislative enactments, rules and regulations issued by
          the Cooperative Development Authority (CDA), PAFCPIC By-Laws,
          decisions of the General Assembly and the Board of Directors and
          policiespromulgated by the CDA and byPAFCPIC.
        </div>
        <div class="mb-4">
          <b>g.</b> Promoted the aims and purpose of the cooperative;the success
          of its business; the welfare of its members; and the cooperative
          movement as a whole.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(3) Quorum</span> - Twenty-Five percent (25%) of the members entitled
          to vote who participated in the three (3) previous General Assembly,
          whichever is higher.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(4) General Assembly (GA)</span> - composed of members entitled to
          vote duly assembled, which has the power:
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> To elect directors, officers and committee members and to
          remove them for cause;
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> To hear and pass upon the reports of the Board of Directors,
          Officers and Committees;
        </div>
        <div class="mb-4">
          <span class="font-semibold">c.</span> To exercise final authority on all matters vitally affecting
          the Cooperative, subject to legal restrictions;
        </div>
        <div class="mb-4">
          <span class="font-semibold">d.</span> To act on the amendments in the Article of Cooperation
          and/or By-laws;
        </div>
        <div class="mb-4">
          <span class="font-semibold">e.</span> To approve developmental plans of the Cooperative; and,
        </div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> To exercise all the powers expressly provided by law and the
          By-laws or reasonably implied therefrom.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(5) Board of Directors (BOD)</span> - Duly elected official by the
          General Assembly who shall direct and supervise the business, manage
          the property of the Cooperative and may by resolution, exercise all
          such powers of the Cooperative that are not reserved for the GA under
          the existing laws.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(6) Poll Clerk</span> - a member-cooperator designated by the Election
          Committee (ELECOM) to assist in receiving and processing of
          representative forms, conduct of registration and canvassing of votes,
          and other election duties.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(7) Protest</span> - a sworn complaint filed by a candidate at any
          stage of the election period.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(8) Representative Vote</span> - a vote delegated by a member to
          another member of the Cooperative for the purpose of election and
          other forms of action requiring the assent and/or dissent of the
          member.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(9) Representative Vote Holder</span> - a member with a delegated vote
          from another member of the Cooperative for the purpose of election.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(10) Representative Form</span> - an official form in which a regular
          member nominates and appoints his/her representative to vote on behalf
          of his/her during election.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(11) Candidate</span> - a member declared to be in good standing and
          is deemed qualified by the ELECOM to run in any elective position of
          the Cooperative.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(12) Walk-in Voter</span> - a member who appears during the Election
          Day who constitutes a single vote.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(13) Validation Clerk</span> - a member cooperator appointed by the
          ELECOM to perform validation duties for a certain period based on the
          representative forms submitted.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(14) Polling Place</span> - the designated place where the election
          will be held.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(15) Election Committee (ELECOM)</span> - Promulgates rules and
          regulations in the conduct of election, implement election rules and
          guidelines duly approved by the GA: recommend necessary amendments to
          the election rules and guidelines, in consultation with the Board of
          Directors for the GA’s approval, pass upon the qualifications of the
          candidates, supervise the conduct, manner and procedure of election
          and other election related activities and on the changes thereto,
          canvass and certify in writing the results of the election, proclaim
          the winning candidates and hear and decide election protests.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(16) Mobile App</span> - a downloadable online application designed to
          be used by members to cast their votes during elections with the use
          of gadgets such as smartphones, tablets, and desktop computers.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(17) PAFCPIC Web Page</span> - is the official web page of PAFCPIC
          where all announcements and information about PAFCPIC are published.
        </div>
        <div class="mb-4">
          <span class="font-semibold">(18) PSO On-Site Voting</span> - a manner of the election in which
          members can cast their votes by way of visiting their designated PSOs
          and utilizing the designated voting station installed thereat. ELECOM
          Representatives or deputized Poll Clerks will oversee the conduct of
          voting at the PSOs.
        </div>
        <div class="font-bold mb-4">ARTICLE 3. - APPLICABILITY</div>
        <div class="mb-4">
          This Code shall govern the procedures in the conduct of election of
          the BOD and other elective positions of the Cooperative.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 4. - RIGHT AND OBLIGATION TO REGISTER AND VOTE
        </div>
        <div class="mb-4">
          It shall be the right and obligation of every Member Entitled to Vote
          (MEV)to register and cast his/hervote and participate in any other
          electoral proceeding/activity of the Cooperative.
        </div>
        <div class="font-bold mb-4">ARTICLE 5. - SCHEDULE OF ACTIVITIES</div>
        <div class="mb-4">
          <span class="font-semibold">Section 1.</span> Election Period. Election period shall commence upon
          the posting of the notice of Election and ends upon completion of all
          scheduled manner of election and formal proclamation of winning
          candidates during the special board meeting. The notice of election
          may be included in the notice of the GA, if the election will be held
          simultaneously with the GA. The election period will depend on the
          declared period of election by the ELECOM to meet the quorum of the
          voting members.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 2.</span> Schedule of Election Activities. Following are the
          schedule of election activities for the election of Board of Directors
          (BOD), Audit and Supervisory Committee (ASC) and Election Committee
          (ELECOM).
        </div>
        <div class="font-bold mb-4">A.Pre-Election</div>
        <div class="mb-4">
          <span class="font-semibold">1.</span> Announcement of Vacancy - Position on the PAFCPIC BOD, ASC
          and ELECOM for regular members to be vacated for the incoming period
          shall be published/announced thru the Cooperative Secretary to all
          members nationwide through a memorandum published by PAFCPIC main and
          satellite offices.
        </div>
        <div class="mb-4">
          <span class="font-semibold">2.</span> Availability of Representative Forms - Representative Forms
          shall be made available to all members four (4) months prior to the
          last day of acceptance of representative forms. Duly accomplished
          representative forms shall be entertained and registered with the
          ELECOM.
        </div>
        <div class="mb-4">
          <span class="font-semibold">3.</span> Filing of Certificate of Candidacy (COC) - Interested Cooperative
          member shall file his/her COC and duly received by ELECOM or the
          Cooperative Secretary will be honored not later than the close of
          office hours on the last day of filing of candidacy. Filing of COCs
          can be extended for a certain period of time ifcircumstances arise to
          justify such extension. At no instance, however, shall it violate the
          right of members who filed their candidacy before the expiration of
          the deadline for the filing of COC.
        </div>
        <div class="mb-4">
          <span class="font-semibold">4.</span> Publication of Qualified Candidates - ELECOM shall submit the names
          of qualified candidates running for different positions tothe
          Cooperative Secretary for publication.
        </div>
        <div class="mb-4">
          <span class="font-semibold">5.</span> Representative Forms Validation - ELECOM shall appoint validation
          clerks who will examine the duly-signedrepresentative forms and shall
          supervise the process thereof. Validation clerks shall examine the
          correctness of each representative forms from the cooperative database
          in order to determine the name of MEVand the authenticity of
          his/hercorresponding signature. Validated representative forms will be
          counted as one vote. Invalid forms will be discarded automatically.
          Date of validation shall be determined by the ELECOM.
        </div>
        <div class="mb-4">
          <span class="font-semibold">6.</span> Campaign Period - The campaign period of the candidates shall be
          determined by the ELECOM through publication. Last day of the campaign
          shall be a day before the election date.
        </div>
        <div class="mb-4">
          <span class="font-semibold">7.</span> Casting of Votes - Members can cast their votes in either of the
          three (3) different modes or manners, such as Face-to-Face voting, PSO
          On-Site Voting, and through Mobile App Voting. In Face-to-Face voting,
          members registration shall be done by presenting the members
          cooperative identification card. Registration committee shall
          determine if a member is a representative vote holder or a walk-in
          voter. Walk-in voters and representative vote holders can
          simultaneously vote within the prescribed time to be announced by the
          ELECOM which shall commence immediately after the approval of the
          Revised Election Code for CY 2022 during the general assembly. ELECOM
          members are allowed to represent any vote as long as it is entrusted
          by the said member. For On- Site voting, members can go directly to
          their designated PSOs and utilize the designated voting station
          installed thereat. They will be assisted by ELECOM Representative or
          Deputized Poll Clerk who will supervise and oversee the conduct of the
          election. In Mobile Application voting, members can also cast their
          votes by downloading the mobile app through IOS App Store or Android
          Play Store or by simply clicking the link found in the PAFCPIC web
          page redirecting the voter to download the mobile app.Upon download,
          they will be prompted to register their identity credentials which
          will be used as proof of legitimacy for their votes to be counted and
          subsequently they can cast their votes.
        </div>
        <div class="mb-4">
          <span class="font-semibold">8.</span> Counting and Canvassing of Votes - Counting and canvassing of votes
          shall be done through a fast and secured electronic means.
        </div>
        <div class="mb-4">
          <span class="font-semibold">9.</span> Publication of the Result of Canvassing of Votes - ELECOM
          Chairperson shall publish the initial result of the election at the
          conclusion of the GA Meeting and subsequently announce the winning
          candidates after the election period has been completed.
        </div>
        <div class="mb-4">
          <span class="font-semibold">10.</span> Voting Procedures - Voting shall only be done upon successful
          registration either in person, through a representative holder or via
          mobile app. Voting shall start as published by the ELECOM through the
          Board Secretary. During the face-to-face voting, the Board Secretary
          will turn over the floor to the ELECOM Chairperson to officially
          announce the start of voting.
        </div>
        <div class="mb-4">
          The following are the voting procedures for walk-in and representative
          vote holder voters:
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Walk-in and representative holders shall present his/her
          cooperative identification card or Military ID to the registration
          booth for checking as to the MEV.
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> Voters shall proceed to the polling booths provided for FILLING UP
          his/her ballot. Ballots must be filled up with THE names of THE CHOSEN
          candidates.
        </div>
        <div class="mb-4">
          <span class="font-semibold">c.</span> He/she hands over the printed ballot to the poll clerk for his/her
          signature on the DESIGNATED stub provided for IN THE BALLOT.
        </div>
        <div class="mb-4"><span class="font-semibold">d.</span> The ballots shall be dropped in the designated ballot box.</div>
        <div class="mb-4">Voting procedures for PSO On-Site Voters:</div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> On-Site voters shall present their cooperative identification card
          or Military ID to the ELECOM representative or Poll Clerk in their
          designated PSO for checking as to the MEV.
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> After verification, voters will be assisted by Poll Clerks to
          enable them to use the tablet provided for on-site voting and begin
          entering identity credentials to successfully cast their votes.
        </div>
        <div class="mb-4">Voting procedures for Mobile App Voters:</div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Mobile App voters shall first download the PAFCPIC mobile app from
          the Play Store or App Store of their Android or IOS smart phones. Upon
          successful download, they will be prompted to sign in by entering
          their identity credentials to determine authenticity and validity of
          voting entitlement. They can also access the mobile app through the
          official web page of PAFCPIC by clicking the link found therein.
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> Voters will receive a One-Time-Pin (OTP) to enable them to proceed
          to casting of votes to their chosen candidates.
        </div>
        <div class="mb-4">
          <span class="font-semibold">B.</span> Post-Election - Oath taking of winning candidates - 2ND Saturday of
          the preceding week after the GA.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 6. - QUALIFICATION AND DISQUALIFICATION OF CANDIDATES FOR
          BOARD OF DIRECTORS (BOD), AUDIT AND SUPERVISORY COMMITTEE (ASC) &
          ELECTION COMMITTEE (ELECOM)
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 3.</span> Qualifications of a Candidate. Except for re-electionist,
          ELECOM shall not accept, merit and consider any Certificate of
          Candidacy (COC) of the candidates unless the applicant possesses the
          following qualifications:
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Must be a regular member entitled to votein the Cooperative; for
          the Board of Directors, the candidates must have a Baccalaureate
          Degree. For the Audit and Supervisory Committee, the candidate is
          preferred to have a degree in accounting or has at least five (5)
          years experience of training in related discipline;
        </div>
        <div class="mb-4"><span class="font-semibold">b.</span> He/she must be of proven integrity, probity and honesty;</div>
        <div class="mb-4"><span class="font-semibold">c.</span> He/she must be of good moral character;</div>
        <div class="mb-4">
          <span class="font-semibold">d.</span> He/she has continuously patronized the cooperative services;
        </div>
        <div class="mb-4">
          <span class="font-semibold">e.</span> For new candidates,he/she has completed or willing to complete the
          required education and training as may be provided by laws, rules and
          regulations and policy approved by the GA; and,
        </div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> He/she has the time and willingness to serve the Cooperative.
        </div>
        <div class="mb-4">
          <span class="font-semibold">g.</span> He/she must have attended and completed the required Cooperative-
          related seminars and trainings.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 4.</span> Disqualifications of a Candidate. Any regular member, who
          is covered by the following circumstances, is disqualified to run for
          elective position.
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Those having conflict of interest with the business of the
          Cooperative
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> Those having been convicted of any crime involving moral turpitude,
          gross negligence, or gross misconduct in the performance of their
          duties or found culpable in any administrative case involving such
          offenses.
        </div>
        <div class="mb-4"><span class="font-semibold">c.</span> Those full time employee/s of the PAFCPIC Cooperative.</div>
        <div class="mb-4">
          <span class="font-semibold">d.</span> He/she holdsany elective position in the government, except that of
          a cooperativeparty list representative, unless otherwise provided by
          law.
        </div>
        <div class="mb-4">
          <span class="font-semibold">e.</span> Those having served hereafter three (3) consecutive terms
          immediately preceding the election. This requirement shall not be
          applicable for candidates who were extended or retain their elected
          seats and remain in their position in a hold-over capacity in CY 2021.
        </div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> An incumbent member of any committee who files a Certificate of
          Candidacy (COC) for higher office shall be deemed resigned from his
          current position.
        </div>
        <div class="mb-4">
          <span class="font-semibold">g.</span> Those having been disqualified pursuant to disqualifications
          prescribed by the Law or the CDA.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 5.</span> Mandatory Training. A candidate who was previously elected
          as an officer of the Cooperative must have complied with the mandatory
          training requirements during their term as provided for in CDA
          Memorandum Circular 2015- 09.Non-compliance with the training
          requirements shall be one of the grounds for disqualification of a
          candidate seeking re-election until such time that he/she has complied
          with the required training. The Cooperative shall ensure that all
          officers shall undertake/comply with the mandatory training during
          their term.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 6.</span> Letter of Intent and Plan. Each and every candidate shall
          be allowed to express his/her COC sent thru ELECOM or thru the
          Cooperative Secretariat. The express plan of a candidate may be
          indicated in the publication of the qualified candidate.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 7.</span> Disqualification Notice. Any member who filed his/her COC
          whose application was not accepted, given merit and considered by the
          ELECOM or has been disqualified, shall be notified at the soonest
          possible time of his/her disqualification and the reasons thereof. The
          disqualified candidate may appeal for his/her disqualification within
          five (5) days from receipt of the notice of disqualification. The
          ELECOM shall decide on the merit of the appeal within five (5) days
          upon receipt of the appeal. The decision of the ELECOM is appealable
          to the Cooperative Development Authority (CDA).
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 8.</span> Withdrawal of Candidacy. Officially approved candidates can
          withdraw from his or her candidacy by officially writing to the
          election committee one (1) week before the scheduled election.
        </div>
        <div class="font-bold mb-4">ARTICLE 7. - VALIDATING CLERKS</div>
        <div class="mb-4">
          <span class="font-semibold">Section 9.</span> Appointment of Validating Clerk. The ELECOM may appoint Ten
          (10) validating clerks to screen representative votes. Validating
          Clerks shall not be an incumbent official of the cooperative nor are
          related to any candidate seeking election.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 10.</span> Duties of Validating Clerks. The Validating Clerks shall
          have the following duties under the supervision of the ELECOM:
        </div>
        <div class="mb-4"><span class="font-semibold">a.</span> Validaterepresentative votes</div>
        <div class="mb-4"><span class="font-semibold">b.</span> Assist in receiving and validating representative votes</div>
        <div class="mb-4"><span class="font-semibold">c.</span> Assist in the conduct of the election</div>
        <div class="mb-4"><span class="font-semibold">d.</span> Assist in the canvassing of votes</div>
        <div class="font-bold mb-4">ARTICLE 8. - POLL CLERKS</div>
        <div class="mb-4">
          <span class="font-semibold">Section 11.</span> Appointment of Poll Clerks. The ELECOM shall appoint ten
          (10) Poll Clerks before the scheduled election. However, in case that
          voting will also be done in designated PSOs for On-site voting, ELECOM
          may appoint additional Poll Clerks to assist in the conduct of
          elections at PSOs. Poll Clerks as deputized by ELECOM may act as
          ELECOM Representative and shall exercise fairness and equality
          throughout the conduct of the election period. Poll Clerks shall not
          be an incumbent official of the Cooperative nor are related to any
          candidate seeking election. The ELECOM shall exercise over-all control
          and authority over the appointed Poll Clerks. It may overrule any
          action/decision of the designated Poll Clerks, if warranted.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 12.</span> Duties of Poll Clerks. The poll clerks shall have the
          following duties under the supervision of the ELECOM:
        </div>
        <div class="mb-4"><span class="font-semibold">a.</span> Assist in the conduct of election</div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> See to it that election is conducted in an orderly manner and in
          accordance with the minimum standard health protocols set forth by the
          IATF-MEID.
        </div>
        <div class="mb-4"><span class="font-semibold">c.</span> Assist the voters during the election proper</div>
        <div class="mb-4"><span class="font-semibold">d.</span> Control the movement of voters for smooth election</div>
        <div class="font-bold mb-4">ARTICLE 9. - FUNCTION AND DUTIES</div>
        <div class="mb-4 font-bold">
          Section 13. Function and Duties of ELECOM:
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> Formulate election rules and guidelines and recommend to the GA for
        </div>
        approval
        <div class="mb-4">
          <span class="font-semibold">b.</span> Implement election rules and guidelines duly approved by the GA
        </div>
        <div class="mb-4">
          <span class="font-semibold">c.</span> Recommend necessary amendments to the election rules and
          guidelines, in consultation with the BOD, for approval bythe GA
        </div>
        <div class="mb-4"><span class="font-semibold">d.</span> Supervise the validation of representative votes</div>
        <div class="mb-4"><span class="font-semibold">e.</span> Canvass and certify the results of the election</div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> Enforce and administer all proceedings relative to the conduct of
          elections for the purpose of enduring free, orderly, and honest
          elections.
        </div>
        <div class="mb-4"><span class="font-semibold">g.</span> Proclaim the winning candidates.</div>
        <div class="mb-4">
          <span class="font-semibold">h.</span> Decide election and other related cases except those involving the
          Election committee or its members.
        </div>
        <div class="mb-4">
          <span class="font-semibold">i.</span> Perform such other functions as prescribed in the PAFCPIC By-Laws.
        </div>
        <div class="font-bold mb-4">ARTICLE 10. - RULES OF VOTING</div>
        <div class="mb-4">
          <span class="font-semibold">Section 14.</span> Rules of Voting. Guidelines in the casting of votes during
          the elections.
        </div>
        <div class="mb-4">
          <span class="font-semibold">a.</span> The election of the BOD and other elective officers shall be held
          in accordance with the By-Laws of the Cooperative.
        </div>
        <div class="mb-4">
          <span class="font-semibold">b.</span> All members in good standing shall be entitled to one (1) vote
          regardless of the number of shares subscribed or paid with the
          Cooperative. However, representative voting shall be allowed and
          permitted which means that a member may delegate to any member
          entitled to vote in his/her behalf on all matters expressly stated in
          the authorization as representative.
        </div>
        <div class="mb-4">
          <span class="font-semibold">c.</span> No single member shall be allowed to register and vote more than
          100 member votes including that of his/her own. Representative votes
          shall be valid only for an election that is being held for which it
          was made.
        </div>
        <div class="mb-4">
          <span class="font-semibold">d.</span> Election shall be done through secured electronic voting for the
          faster, safer, credible, and efficient casting of votes.
        </div>
        <div class="mb-4">
          <span class="font-semibold">e.</span> The election shall be conducted in a practical, convenient, and
          most economical manner. Votes shall be cast without undue
          intimidation/influence from the candidates or any person related to
          them. Campaign paraphernalia/ materials shall be limited at the most
          to one coupon bond size only, to be displayed in the designated area.
          No streamer and other forms of campaign gimmicks shall be allowed to
          be posted or conducted in the polling booths. As a Cooperative, it is
          the duty of every member-cooperator to uphold the integrity of the
          electoral process.
        </div>
        <div class="mb-4">
          <span class="font-semibold">f.</span> Voting during the Regular GA shall be held annually within ninety
          (90) days after the close of its fiscal year, within its area of
          operation and such time and date as the Board may designate.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 11. COUNTING & CANVASSING.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 15.</span> Counting & Canvassing. Counting and Canvassing of votes
          shall commence after the Chairperson, ELECOM announces the end of the
          casting of votes. Votes shall be counted and securely transmitted
          electronically to the main server for consolidation. The number of
          votes for each candidate will be electronically generated and the
          results of the election shall be known immediately.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 12. - PROCLAMATION OF WINNERS
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 16.</span> Proclamation of Winners. The winner/s of the election
          shall be proclaimed by the Chairperson of the ELECOM upon completion
          of the election period or as decided by the BOD without prejudice to
          the election protest filed against the winner.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 17.</span> Publication of Votes Received. The Chairperson of the
          ELECOM shall make known upon completion of the election periodthe
          number of votes garnered by the winners from the highest to the
          lowest.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 17.</span> Publication of Votes Received. The Chairperson of the
          ELECOM shall make known upon completion of the election periodthe
          number of votes garnered by the winners from the highest to the
          lowest.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 19.</span> Disposition of Votes. Immediately after the protest period
          and the newly elected officers have taken their oath, all
          paraphernalia used during the exercise shall be placedunder the
          custodyof the Board Secretary who shall dispose of the same within a
          period of months after being satisfied that there is no pending
          controversy before the CDA.
        </div>
        <div class="font-bold mb-4">ARTICLE 13. - ELECTION CONTESTS</div>
        <div class="mb-4">
          <span class="font-semibold">Section 20.</span> Period of Filing Election Protests. Sworn protest must be
          accomplished in writing and may be filed at any stage of the election
          proceedings but not beyond twenty-four (24) hours after the
          proclamation of the winning candidates. The protest shall state
          therein, the grounds and evidence whatsoever for deliberation and
          consideration by the ELECOM. The protesting party shall shoulder the
          expenses involved therein. Protests filed beyond the twenty-four (24)
          hours period after the proclamation of winning candidates may be
          entertained by the ELECOM for the imposition of appropriate
          administrative and corrective measures but shall no longer affect the
          result of the election. All protests shall be immediately acted upon
          by the ELECOM whose decision shall be final if not seasonablyappealed
          to the CDA within fifteen (15) days after receipts of the
          ELECOM/BODdecision.
        </div>
        <div class="font-bold mb-4">ARTICLE 14. OATH OF OFFICE</div>
        <div class="mb-4">
          <span class="font-semibold">Section 21.</span> Date of Oath Taking. Proclamation of winners shall be held
          during the Special Board Meeting called for the purpose. The decision
          of the ELECOM shall be final. The date of the oath-taking of newly
          elected Officers shall be on the succeeding week after the
          electionperiod. In the event of unforeseen circumstances, oath-taking
          will be moved to a date determined by the BOD.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 15. ASSUMPTION AND TERM OF OFFICE
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 22.</span> Assumption of Office. Immediately after the oath-taking,
          the newly elected officers shall assume office.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 23.</span> Term of Office. The term of office of the newly elected
          officers shall be two(2) years as provided by the By-Laws unless
          terminated earlier for cause, or have resigned or become incapacitated
          due to illness or death, and until their successor have been elected,
          qualified and have discharged the duties of the office, provided that
          no elected officers shall serve for more than three (3) consecutive
          terms. In case of the elected ELECOM members, they shall not seek
          re-election or run for another elected position during his/her
          incumbency. However, in the upcoming General Assembly and Election IN
          CY 2022, the top eight (8) candidates for Board of Directors with a
          minimum category composition of three (3) Officers, three (3) Enlisted
          Personnel and two (2) Civilian who garnered the highest number of
          votes shall serve for two (2) years while those remaining seven (7)
          candidates who got the next highest number of votes shall only serve
          for one (1) year or till the next commencement of election. Similar
          condition applies to the ELECOM members wherein the three (3)
          candidates who got most votes shall serve for two (2) years and the
          remaining two (2) candidates who got the next highest number of votes
          shall only serve for one (1) year. Thereafter, the selection of
          Officers and Committee members will return to its normal procedure as
          provided in the PAFCPIC By-Laws.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 16. REPEALING CLAUSE AND ADDITIONAL AUTHORITY
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 24.</span> Applicability. This 2022 Revised PAFCPIC Election Code is
          applicable until such time that the same or any of its provisions has
          been amended, repealed or modified accordingly.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 25.</span> Repealing Clause. The Revised PAFCPIC Election Code of
          2016, The Election Code of the Philippine Army Finance Center
          Producers Cooperative (PAFCPIC) of 1994 and the revised Election Code
          of PAFCPIC 2001 together with their implementing rules and regulations
          inconsistent with this Code are herebyrescinded.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 26.</span> Additional Authority. In case of doubt as to the meaning
          of any provision of this Code and/or the Implementing Rules and
          Regulations issued in pursuance thereof, the same shall be resolved
          liberally in favor of the intent and spirit of upholding the electoral
          processes. Nothing herein shall preclude the PAFCPIC ELECOM from
          promulgating additional rules, with due notice, in order to promote a
          fair and just election.
        </div>
        <div class="font-bold mb-4">
          ARTICLE 17. EFFECTIVITY AND PUBLICATION.
        </div>
        <div class="mb-4">
          <span class="font-semibold">Section 27.</span> Effectivity and Publication. This Revised PAFCPIC Election
          Code 2022 shall take effect as amended and revised by the ELECOM upon
          approval by the General Assembly. A copy thereof shall be published in
          the PAFCPIC official publication and social media accounts for widest
          dissemination to the entire members.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  name: "ElectionPolicyControl",
};
</script>
<style></style>
